var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameLikeOn = function SvgIconStorygameLikeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.083 3.354c.854 0 1.673.34 2.276.943l.391.39.39-.39a3.22 3.22 0 0 1 2.277-.943c1.84 0 3.333 1.491 3.333 3.332v.334c0 2.545-4.318 5.914-5.628 6.878a.624.624 0 0 1-.744 0C7.068 12.934 2.75 9.565 2.75 7.02v-.334a3.332 3.332 0 0 1 3.333-3.332Z",
    fill: "#9457EB"
  })));
};
export default SvgIconStorygameLikeOn;